<template>
  <page-status class="eproposal-index" :loading="loading">
    <div class="tooltips">
      <div class="icon">
        <img
          src="http://i3.cathay-ins.com.cn/prod/posts/1ccbd6931aa2a45c29fdbc5ff34e1357.png"
          alt="notice"
        />
      </div>
      <div class="text">请阅读至页面底部，待按钮亮起后完成确认</div>
    </div>
    <div class="new-energy" @scroll="handleScroll">
      <img
        src="https://i3.cathay-ins.com.cn/prod/posts/8e1d6554609d562364eaf7a7b6195f63.jpg"
        alt=""
      />
    </div>
    <div class="bottom-button">
      <van-button
        :disabled="isClick"
        class="button"
        type="info"
        @click="readed()"
      >
        下一步
      </van-button>
    </div>
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import { Toast } from 'vant';
import * as services from '@/services';

export default {
  components: {
    PageStatus,
  },

  data() {
    return {
      loading: false,
      isClick: true,
    };
  },

  methods: {
    readed() {
      if (this.isClick) {
        Toast({ message: '请阅读到底部' });
        return;
      }
      this.fetchData();
    },
    fetchData() {
      const { businessNo, code } = this.$route.query;
      services
        .eproposalShift(businessNo)
        .then(res => {
          const { content } = res;
          if (content) {
            const newUrl = code ? `${content}&code=${code}` : content;
            window.location.replace(newUrl);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleScroll(event) {
      const element = event.target;

      // 判断是否滚动到底部
      if (
        Math.abs(
          element.scrollHeight - element.scrollTop - element.clientHeight,
        ) < 1
      ) {
        this.isClick = false;
      }
    },
  },
};
</script>

<style lang="less">
.tooltips {
  background-color: #fff9ed;
  width: 718px;
  padding: 0 16px;
  height: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  .icon {
    width: 20px;
    height: 20px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .text {
    font-size: 14px;
    color: #ff6010;
    margin-left: 10px;
  }
  .clause-name {
    img {
      width: 20px;
    }
  }
}
.new-energy {
  height: 100vh;
  overflow-y: scroll;
  img {
    width: 100%;
    margin-bottom: 50px;
  }
}
.bottom-button {
  width: 100%;
  position: fixed;
  bottom: 0;
  background: #fff;
  .button {
    width: 100%;
    flex: 1;
    border-radius: 4px;

    & + .button {
      margin-left: 12px;
    }
  }
}
</style>
